import React from "react";
import support from "../../assets/images/supportImg.png";

const Support = () => {
  return (
    <div className="py-6 sm:py-20 w-full mx-4 sm:mx-12 flex flex-col-reverse md:flex-row gap-5 sm:gap-10 justify-center">
      <div className="relative max-w-[1300px] h-[300px] sm:h-[500px] w-full">
        <div
          className="absolute inset-0 bg-cover bg-center rounded-2xl"
          style={{ backgroundImage: `url(${support})` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-l from-[#0CACDE66]/40 to-[#0CACDEE5]/90 rounded-2xl"></div>
        <div className="relative z-10 px-4 sm:px-20 text-white flex flex-col w-full h-full justify-center">
          <h1 className="text-3xl sm:text-5xl">You Deserve Support.</h1>
          <span className="text-3xl sm:text-5xl italic font-eiko-thin">
            Begin Your Journey to Mental Wellness with Us
          </span>
        </div>
      </div>
    </div>
  );
};

export default Support;
